module.exports = __webpack_public_path__ + "static/media/fly0081.8d4d04c5.webp";